import React, { useEffect, useRef } from 'react';
import './styles/global.css';

// Components
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import About from './components/About';
import Skills from './components/Skills';
import Projects from './components/Projects';
import Experience from './components/Experience';
import Education from './components/Education';
import Contact from './components/Contact';
import ChatBubble from './components/ChatBubble';
import Footer from './components/Footer';
import PhotoCollage from './components/PhotoCollage';

function Cursor() {
  const cursorRef = useRef(null);
  const ringRef = useRef(null);

  useEffect(() => {
    const cursor = cursorRef.current;
    const ring = ringRef.current;
    if (!cursor || !ring) return;

    let cx = window.innerWidth / 2;
    let cy = window.innerHeight / 2;
    let rx = cx, ry = cy;
    let raf;

    const onMove = (e) => {
      cx = e.clientX;
      cy = e.clientY;
    };

    const tick = () => {
      cursor.style.left = cx + 'px';
      cursor.style.top = cy + 'px';
      rx += (cx - rx) * 0.12;
      ry += (cy - ry) * 0.12;
      ring.style.left = rx + 'px';
      ring.style.top = ry + 'px';
      raf = requestAnimationFrame(tick);
    };

    const onEnterLink = () => document.body.classList.add('cursor-hover');
    const onLeaveLink = () => document.body.classList.remove('cursor-hover');

    window.addEventListener('mousemove', onMove);
    raf = requestAnimationFrame(tick);

    const links = document.querySelectorAll('a, button, [role="button"]');
    links.forEach(el => {
      el.addEventListener('mouseenter', onEnterLink);
      el.addEventListener('mouseleave', onLeaveLink);
    });

    return () => {
      window.removeEventListener('mousemove', onMove);
      cancelAnimationFrame(raf);
      links.forEach(el => {
        el.removeEventListener('mouseenter', onEnterLink);
        el.removeEventListener('mouseleave', onLeaveLink);
      });
    };
  }, []);

  return (
    <>
      <div ref={cursorRef} className="cursor" />
      <div ref={ringRef} className="cursor-ring" />
    </>
  );
}

export default function App() {
  return (
    <>
      {/* Ambient BG */}
      <div className="grid-bg" />
      <div className="scanlines" />
      <div className="noise" />

      {/* Cursor */}
      <Cursor />

      {/* Navigation */}
      <Navbar />

      {/* Main Content */}
      <main>
        <Hero />
        <About />

        <Skills />
        <Projects />
        <Experience />
        <Education />
        <PhotoCollage />
        <Contact />
      </main>

      {/* Footer */}
      <Footer />

      {/* Chat Bubble */}
      <ChatBubble />
    </>
  );
}
